export const ARTICLE_ADDED = 'Noticia agregada'
export const ARTICLE_UPDATED = 'Noticia actualizada'
export const ARTICLE_DELETED = 'Noticia eliminada'
